import { render, staticRenderFns } from "./TravelTable.vue?vue&type=template&id=0b2f337a&scoped=true"
import script from "./TravelTable.vue?vue&type=script&lang=ts"
export * from "./TravelTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2f337a",
  null
  
)

export default component.exports